import {Button, ButtonGroup, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {Done, NotInterested} from "@mui/icons-material";
import React from "react";
import {useTranslation} from "react-i18next";

const YesNo = ({name, value='0'}) => {
    const {t} = useTranslation();

    const [internalValue, setInternalValue] = React.useState(value === '1' || value === true);


    return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "20px", margin: "20px 0"}}>
            <a className={`btn ${internalValue ? "btn-invert" : ""}`} onClick={() => setInternalValue(false)}>NIE</a>
            <a className={`btn ${!internalValue ? "btn-invert" : ""}`} onClick={() => setInternalValue(true)}>TAK</a>
            <input type="hidden" value={internalValue ? '1' : '0'} name={name} />
        </div>
    );
}
export default YesNo;
